
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import {mapState,mapMutations} from 'vuex'
export default {
components: {
Tabbar,
TabbarItem
},
data(){
return{
activeIndex: '1',
activeIndex2: '1'
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN();
},
methods:{
...mapMutations(['SETTOKEN']),
handleSelect(key, keyPath) {
console.log(key, keyPath);
}
},
watch: {
},
}



// WEBPACK FOOTER //
// ./src/pages/home.vue